import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from 'uuid'; 

interface InitialState {
  authToken: string | null;
  isAuthenticated: boolean;
  mobileNumber: string;
  isMobileVerified: boolean;
}

const initialState: InitialState = {
  authToken: sessionStorage.getItem('authToken') || null,
  isAuthenticated: !!localStorage.getItem('authToken'), 
  mobileNumber: '',
  isMobileVerified: false,
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    signIn: (state, action: PayloadAction<{ token?: string }>) => {
      const token = action.payload.token || uuidv4(); // Generate a random token
      state.authToken = token;
      state.isAuthenticated = true;
      localStorage.setItem('authToken', token); // Save token to localStorage
    }, 
    signOut: (state) => {
      state.isAuthenticated = false;
      state.authToken = null;
      localStorage.removeItem('authToken');
    },
    setMobileNumber(state, action: PayloadAction<string>) {
      state.mobileNumber = action.payload;
    },
    setMobileVerified(state, action: PayloadAction<boolean>) {
      state.isMobileVerified = action.payload; // Update verification status
    },
  },
});

export const { signIn, signOut, setMobileNumber, setMobileVerified  } = authSlice.actions;
export default authSlice;
